import { call, put, takeEvery } from 'redux-saga/effects'
import { userLogin, userLoginSuccess, userLoginFailed } from './slice'
import { API } from 'src/admin/services'

function* login({ payload }) {
  try {
    const response = yield call(API.authApi.loginApi, payload)
    if (
      response?.status === 200 &&
      response?.data &&
      response?.data?.code === 0 &&
      response?.data?.error === false
    ) {
      yield put(userLoginSuccess({ payload: response?.data }))
    } else {
      yield put(userLoginFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(userLoginFailed({ message: error?.message }))
  }
}

function* authSaga() {
  yield takeEvery(userLogin, login)
}

export default authSaga
